import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import GraphQl from '../../GraphQL';
import { responsibleListAllQuery } from '../../shared/queries/Responsible';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import MatTable from '../../shared/components/material-table';
import columns from './components/Columns';
import { formatCpf, concatPhones } from '../../shared/format/format';

const Responsible = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const { t, history, dispatch } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const loadData = () => {
    const query = responsibleListAllQuery(true);
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.responsibleListAll = res.responsibleListAll.map((item) => ({
          ...item,
          formattedCpf: formatCpf(item.cpf),
          phones: concatPhones(item),
          lastAccessDateInFormat:
            item.lastAccessInMilli && item.lastAccessInMilli > 0
              ? format(item.lastAccessInMilli, 'dd/MM/yyyy HH:mm')
              : '',
          engagementStatusInFormat: t(
            `dashboard.engagementBoard.classEngagement.${item.engagementStatus}`
          ),
        }));
        setData(res.responsibleListAll);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const addItemClickHandler = () => {
    history.push('/minime/responsavel/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/responsavel/mnt/${rowData.email}`);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    onRefreshClick={loadData}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    title={t('panels.responsavel')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Responsible.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Responsible)
);
